﻿export const SESSION_KEY = "trades836_session";
const SESSION_DURATION_MS = 30 * 24 * 60 * 60 * 1000;

export function saveSession(user) {
  localStorage.setItem(SESSION_KEY, JSON.stringify({ user, expiresAt: Date.now() + SESSION_DURATION_MS }));
}

export function getSession() {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const session = JSON.parse(raw);
    if (!session.expiresAt || session.expiresAt < Date.now() || !session.user || !session.user.token) {
      clearSession();
      return null;
    }
    return session;
  } catch {
    clearSession();
    return null;
  }
}

export function getToken() {
  const s = getSession();
  return s ? s.user.token : null;
}

export function clearSession() {
  localStorage.removeItem(SESSION_KEY);
}
